module.exports = __webpack_public_path__ + "img/crude-oil.2deff03a.png";